import { Appointment } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function sendBusinessGoogleReviewLink({
  aid,
}: {
  aid: Appointment["aid"];
}): Promise<TrystGenericResponse<undefined>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();

    let endpoint = `${TRYST_HOST}/business/appointment/${aid}/request-review`;
    const res = await fetch(endpoint, {
      method: "POST",
      redirect: "follow",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const raw = await res.text();
    let body: any = {};
    try {
      body = raw ? JSON.parse(raw) : {};
    } catch {
      body = raw ? { message: raw } : {};
    }

    const success =
      typeof body?.success === "boolean" ? body.success : res.ok;

    const bodyError = body?.error;
    const errorMessage =
      typeof bodyError === "string"
        ? bodyError
        : typeof bodyError?.message === "string"
          ? bodyError.message
          : !success
            ? `Request failed (${res.status})`
            : undefined;

    return {
      ...(body || {}),
      success,
      ...(success ? {} : { error: errorMessage }),
    };
  } catch (e) {
    return { success: false, error: "Request failed. Please try again." };
  }
}
